import React from 'react';
import './LegalPage.css';

const AvisoLegal = () => (
    <div className="legal-page">
            <h1>Aviso Legal de Navi</h1>

            <h2>1. Titularidad del sitio web</h2>
            <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI‑CE), se informa que este sitio web, accesible desde el dominio <a href="https://navitechlabs.com">https://navitechlabs.com</a>, es titularidad de:</p>
            <ul>
                    <li><strong>Nombre comercial:</strong> Navi</li>
                    <li><strong>Titulares legales:</strong>
                            <ul>
                                    <li>Juan Manuel Zambrano Obando (NIE: Z1124167R)</li>
                                    <li>Juan Diego Espinosa Rondón (NIE: Z0667628N)</li>
                            </ul>
                    </li>
                    <li><strong>Domicilio fiscal:</strong> C/ Echegaray nº 3, Planta 4ª, Puerta 1, Alcoy (Alicante), España</li>
                    <li><strong>Correo electrónico de contacto:</strong> contacto@navitechlabs.com</li>
                    <li><strong>NIF/CIF:</strong> Pendiente si se registra como empresa (actualmente operan como autónomos)</li>
            </ul>

            <h2>2. Objeto del sitio web</h2>
            <p>El sitio web tiene por objeto ofrecer servicios de consultoría tecnológica, automatización y desarrollo de soluciones digitales basadas en inteligencia artificial para pequeñas y medianas empresas.</p>

            <h2>3. Condiciones de uso</h2>
            <p>La navegación por el sitio web navionline.com atribuye la condición de Usuario, e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal. El Usuario se compromete a hacer un uso adecuado del sitio web conforme a la ley, la moral, el orden público y las presentes condiciones.</p>

            <h2>4. Propiedad intelectual e industrial</h2>
            <p>Todos los contenidos del sitio web (textos, imágenes, logotipos, software, etc.) están protegidos por derechos de propiedad intelectual e industrial, titularidad de Navi o de terceros con licencia de uso. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.</p>

            <h2>5. Enlaces de terceros</h2>
            <p>El sitio puede contener enlaces a páginas web de terceros. Navi no asume responsabilidad alguna por los contenidos, políticas o prácticas de dichos sitios.</p>

            <h2>6. Exención de responsabilidad</h2>
            <p>Navi no se responsabiliza de los daños o perjuicios derivados del acceso, uso o mala utilización de los contenidos del sitio web, ni de eventuales interrupciones del servicio, virus, errores de seguridad, fallos técnicos o ataques informáticos ajenos a su control.</p>

            <h2>7. Legislación aplicable y jurisdicción</h2>
            <p>Este Aviso Legal se rige por la legislación española. En caso de controversia, las partes se someten, con renuncia expresa a cualquier otro fuero, a los juzgados y tribunales de la ciudad de Alcoy (Alicante, España), salvo que la normativa de protección de consumidores disponga otra cosa.</p>
    </div>
);

export default AvisoLegal;
